import { BASE_URL,GET_USERS,UPDATE_USER,CREATE_USER, GET_CORPORATE_USERS  } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IUserInput } from "models/users";
 
export async function getUsers(params: string = "") {
  const response = await axios.get(BASE_URL + GET_USERS + params);
  return response.data;
}
export async function addUser(data: IUserInput) {
  const response = await axios.post(BASE_URL + CREATE_USER, data);
  return response.data;
}
export async function editUser(data: IUserInput) {
  const response = await axios.patch(BASE_URL + UPDATE_USER, data);
  return response.data;
}

export async function getCorporateUsers(params: string = "") {
  const response = await axios.get(BASE_URL + '/GetAllCorporateUsers' + params);
  return response.data;
}
 

export const UserCells: HeadCell[] = [
  {
    id: "userName",
    numeric: false,
    disablePadding: false,
    label: "T_username",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "T_email",
  },
  {
    id: "countryCode",
    numeric: false,
    disablePadding: false,
    label: "T_country_code",
  },
  {
    id: "phoneNumber",
    numeric: false,
    disablePadding: false,
    label: "T_phone_number",
  },
  {
    id: "roleName",
    numeric: false,
    disablePadding: false,
    label: "T_role_name",
  },
  {
    id: "companyId",
    numeric: false,
    disablePadding: false,
    label: "T_company",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
